import { SubscriptionClient } from 'subscriptions-transport-ws';
import { wsApiUrl } from 'helpers/constants';
import { AsyncStorage } from 'services';

export var subscriptionClientStatus = 'uninitiated';

const websocketURL = wsApiUrl as string;
export const subscriptionClient = new SubscriptionClient(websocketURL, {
  timeout: 60000, // how long the client should wait in ms for a keep-alive message from the server
  lazy: true,
  connectionParams: async () => {
    console.log('hello');
    const accessToken = await AsyncStorage.get('accessToken');
    const params = {
      authorization: {
        'FYI-Authorization': 'Bearer ' + accessToken,
      },
    };
    return params;
  },
});

subscriptionClient.onConnected(() => {
  console.log('Websocket connected');
  subscriptionClientStatus = 'connected';
});

subscriptionClient.onConnecting(() => {
  console.log('Websocket connecting');
});

subscriptionClient.onDisconnected((context) => {
  console.log('Websocket disconnected');
  subscriptionClientStatus = 'disconnected';
});

subscriptionClient.onReconnected(() => {
  console.log('Websocket reconnected');
});

subscriptionClient.onError((err) => {
  console.log('Websocket error', err);
});
